import classNames from "classnames";
import { useI18n } from "../../i18n";
import styles from "./Button.module.css";
import { ButtonHTMLAttributes, type FunctionComponent, type ReactElement } from "react";

export type ButtonProps = {
  label: string;
  variant?: "PrimaryGreen" | "PrimaryDark" | "Secondary";
  fullWidth?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: FunctionComponent<ButtonProps> = (props: ButtonProps): ReactElement => {
  const { label, variant = "PrimaryDark", className, fullWidth = true, ...buttonProps } = { ...props };
  const buttonClasses = classNames(styles.button, styles[`variant${variant}`], className, {
    [styles.fullWidth]: fullWidth,
  });
  const { t } = useI18n();

  return (
    <button type="button" {...buttonProps} className={buttonClasses}>
      {t(label)}
    </button>
  );
};
